/**
 * pdfToImage.js — Converte PDF para PNG usando pdfjs-dist
 * 
 * Recebe File object direto (não base64) para evitar corrupção de dados.
 * Retorna base64 SEM prefixo (compatível com o backend).
 */
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

/**
 * Verifica se é PDF — aceita string mimeType ou File object
 */
export function isPdf(input) {
  if (!input) return false;
  if (typeof input === 'string') {
    return input === 'application/pdf' || input.toLowerCase().endsWith('.pdf');
  }
  if (input.type === 'application/pdf') return true;
  if (input.name && input.name.toLowerCase().endsWith('.pdf')) return true;
  return false;
}

/**
 * Converte primeira página de um PDF File em base64 PNG (sem prefixo)
 * @param {File} file - Arquivo PDF (File object do input)
 * @param {object} options - { scale: 2, onProgress: fn }
 * @returns {Promise<{base64: string, width: number, height: number, numPages: number}>}
 */
export async function pdfToImage(file, options = {}) {
  const { scale = 2, onProgress } = options;

  if (onProgress) onProgress('Carregando PDF...');

  // File → ArrayBuffer direto (sem passar por base64)
  const arrayBuffer = await file.arrayBuffer();

  if (onProgress) onProgress('Renderizando página 1...');

  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const page = await pdf.getPage(1);

  const viewport = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  if (onProgress) onProgress('Convertendo para PNG...');

  // base64 SEM prefixo — compatível com convertToBase64() do OrcamentoPlanta
  const dataUrl = canvas.toDataURL('image/png');
  const base64 = dataUrl.split(',')[1];

  console.log(`[PDF→PNG] Convertido: ${canvas.width}x${canvas.height}px, ${pdf.numPages} página(s)`);

  return {
    base64,
    width: canvas.width,
    height: canvas.height,
    numPages: pdf.numPages,
  };
}

export default pdfToImage;
